<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <page-title></page-title>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{procedureAndPatientDetails.label}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{procedureAndPatientDetails.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ procedureAndPatientDetails.description }}</dd>
              <dt class="col-sm-3" v-if="procedureAndPatientDetails.procedureAndPatientDetailCodingSchema">CodingSchema associato</dt>
              <dd class="col-sm-9" v-if="procedureAndPatientDetails.procedureAndPatientDetailCodingSchema">
                <dl class="row">
                  <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
                  <dd class="col-sm-9">
                    <b-badge :variant="`warning`">
                        {{ procedureAndPatientDetails.procedureAndPatientDetailCodingSchema.code }}
                    </b-badge>
                  </dd>
                  <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
                  <dd class="col-sm-9">{{procedureAndPatientDetails.procedureAndPatientDetailCodingSchema.label}}</dd>
                </dl>
              </dd>
            </dl>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import ProcedureAndPatientDetailService from '@/services/ProcedureAndPatientDetailService'
  const procedureAndPatientDetailService = ProcedureAndPatientDetailService.build();
  export default {
    name: 'procedureDetailsShow',
    components: {PageTitle},
    props: {
      id: {
        required: true
      }
    },
    data() {
      return {
        deleteModal: false,
        procedureAndPatientDetails: {}
      }
    },
    created() {
      this.fetchData();
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'})
    },
    methods: {
      async fetchData() {
        this.procedureAndPatientDetails = await procedureAndPatientDetailService.read(this.id);
      }
    }

  }
</script>
